<template>
  <div class="main-contain">
    <div class="module-title">
      <div class="main-title-text main-title">水力性能综合评价指标</div>
      <div class="legend-box">
        <div class="legend rate">实时F值</div>
        <div class="legend f">{{ typeMap[type1] }}</div>
        <div class="legend water">{{ typeMap[type2] }}</div>
      </div>
    </div>
    <div class="line">
      <div class="box btn-box">
        <div
          @click="toBackend(false)"
          class="btn"
        >管理窗口</div>
      </div>
      <div
        class="box"
        @click="showDialog"
      >
        <f-echart
          ref="allChart"
          id="all"
          :showLegend="true"
        ></f-echart>
      </div>
      <div class="box btn-box">
        <div
          @click="toBackend(true)"
          class="btn"
        >远程效率试验窗口</div>
      </div>
    </div>
    <div class="line">
      <div
        class="box"
        @click="showDialog"
      >
        <f-echart
          ref="f1Chart"
          id="f1"
          title="1号机组"
        ></f-echart>
      </div>
      <div
        class="box"
        @click="showDialog"
      >
        <f-echart
          ref="f2Chart"
          id="f2"
          title="2号机组"
        ></f-echart>
      </div>
      <div
        class="box"
        @click="showDialog"
      >
        <f-echart
          ref="f3Chart"
          id="f3"
          title="3号机组"
        ></f-echart>
      </div>
    </div>
    <div class="table-box">
      <div class="box">
        <dv-scroll-board
          class="table"
          :config="config"
        />
      </div>
    </div>
    <model-one-dialog
      title="机组水力性能数据分析"
      width="25%"
      ref="modelOneDialogRef"
      @refresh="getDataByParams"
    />
  </div>
</template>

<script>
import { api } from '@/api/api'
import FEchart from './echartComponents/FEchart.vue'
import ModelOneDialog from './dialogComponents/ModelOneDialog.vue'

export default {
  components: { FEchart, ModelOneDialog },
  data() {
    return {
      type1: 1,
      type2: 2,
      typeMap: {
        1: '日平均F值',
        2: '周平均F值',
        3: '月平均F值',
        4: '季平均F值',
        5: '年平均F值',
      },
      efficiencyMap: {
        1: '日平均机组效率(%)',
        2: '周平均机组效率(%)',
        3: '月平均机组效率(%)',
        4: '季平均机组效率(%)',
        5: '年平均机组效率(%)',
      },
      waterMap: {
        1: '日平均耗水率(m³/kW·h)',
        2: '周平均耗水率(m³/kW·h)',
        3: '月平均耗水率(m³/kW·h)',
        4: '季平均耗水率(m³/kW·h)',
        5: '年平均耗水率(m³/kW·h)',
      },
      config: {
        header: [
          '<span style="color:#08CDF8;"></span>',
          '<span style="color:#08CDF8;">1号机组</span>',
          '<span style="color:#08CDF8;">2号机组</span>',
          '<span style="color:#08CDF8;">3号机组</span>'
        ],
        data: [
          ['实时机组效率(%)', 0, 0, 0],
          ['日平均机组效率(%)', 0, 0, 0],
          ['周平均机组效率(%)', 0, 0, 0],
          ['实时耗水率(m³/kW·h)', 0, 0, 0],
          ['日平均耗水率(m³/kW·h)', 0, 0, 0],
          ['周平均耗水率(m³/kW·h)', 0, 0, 0]
        ],
        align: ['center', 'center', 'center', 'center'],
        waitTime: 1000,
        headerHeight: 30,
        rowNum: 6,
        columnWidth: [180],
        headerBGC: '#0c2e56',
        evenRowBGC: '#09223e',
        oddRowBGC: '#0c2e56'

      },
      propMap: [
        'unitEfficiency',
        'unitEfficiencyByType1',
        'unitEfficiencyByType2',
        'unitWaterRate',
        'unitWaterRateByType1',
        'unitWaterRateByType2'
      ]
    }
  },
  mounted() {

  },
  methods: {
    getDataByParams(params) {
      this.setTitle(params)
      this.$http.get({ url: api.unitHydraulicAnalysis }).then(res => {
        res.data.list.forEach(v => {
          if (!v) v = []
        })
        let dataList = res.data.list
        this.setData(dataList)
      })
    },
    showDialog() {
      this.$refs.modelOneDialogRef.show('ModelTwoDetail')
    },
    toBackend(flag) {
      if (flag) {
        window.open(`https://10.143.40.218:8443/experiment`)
      } else {
        window.open(`https://10.143.40.218:8443/overview/factory`)
      }
    },
    setChartData(dataList) {
      let data1 = [
        (dataList[0].comprehensiveEvaluation).toFixed(2),
        (dataList[0].comprehensiveEvaluationByType1).toFixed(2),
        (dataList[0].comprehensiveEvaluationByType2).toFixed(2),
      ]
      let data2 = [
        (dataList[1].comprehensiveEvaluation).toFixed(2),
        (dataList[1].comprehensiveEvaluationByType1).toFixed(2),
        (dataList[1].comprehensiveEvaluationByType2).toFixed(2),
      ]
      let data3 = [
        (dataList[2].comprehensiveEvaluation).toFixed(2),
        (dataList[2].comprehensiveEvaluationByType1).toFixed(2),
        (dataList[2].comprehensiveEvaluationByType2).toFixed(2),
      ]
      let data4 = [
        (dataList[3].comprehensiveEvaluation).toFixed(2),
        (dataList[3].comprehensiveEvaluationByType1).toFixed(2),
        (dataList[3].comprehensiveEvaluationByType2).toFixed(2),
      ]
      this.$refs.f1Chart.initChart(data1)
      this.$refs.f2Chart.initChart(data2)
      this.$refs.f3Chart.initChart(data3)
      this.$refs.allChart.initChart(data4)
    },
    setTableData(dataList) {
      this.propMap.forEach((item, index) => {
        for (let n = 1; n < 4; n++) {
          let value = dataList[n - 1][item]
          if (item === 'unitEfficiency' && value > 94) {
            value = 93.97;
          } else {
            value = value.toFixed(2);
          }
          this.$set(this.config.data[index], n, value)
        }
      })
      this.config.data.forEach((item, index) => {
        switch (index) {
          case 1:
            item[0] = this.efficiencyMap[this.type1]
            break
          case 2:
            item[0] = this.efficiencyMap[this.type2]
            break
          case 4:
            item[0] = this.waterMap[this.type1]
            break
          case 5:
            item[0] = this.waterMap[this.type2]
            break
          default: break
        }
      })
      let config = { ...this.config }
      this.config = config
    },
    setData(dataList) {
      this.setChartData([...dataList])
      this.setTableData([...dataList])
    },
    setTitle(setting) {
      this.type1 = setting.unitHydraulicAnalysisTimeType1
      this.type2 = setting.unitHydraulicAnalysisTimeType2
    }
  }
}
</script>

<style scoped lang="scss">
.main-contain {
  height: 100%;
  width: 100%;
  .module-title {
    height: 14%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .main-title {
      position: absolute;
      top: 0;
      background-image: url('@/assets/img/itemBg.png');
      background-size: cover;
      width: 380px;
      height: 70px;
      line-height: 70px;
      font-size: 24px;
      color: #fff22f;
    }
    .legend-box {
      position: absolute;
      bottom: 0px;
      display: flex;
      justify-content: center;
      .legend {
        color: #fff;
        position: relative;
        font-size: 15px;
        &:nth-child(1) {
          margin-right: 30px;
        }
        &:nth-child(2) {
          margin-right: 30px;
        }
        &.rate:before {
          content: '';
          position: absolute;
          left: -20px; /* 将圆形置于文本左侧 */
          top: 50%;
          transform: translateY(-50%); /* 垂直居中对齐 */
          width: 12px; /* 圆形的宽度 */
          height: 12px; /* 圆形的高度 */
          background-color: #fec200; /* 圆形的背景颜色 */
          border-radius: 50%; /* 创建圆形 */
        }
        &.f:before {
          content: '';
          position: absolute;
          left: -20px; /* 将圆形置于文本左侧 */
          top: 50%;
          transform: translateY(-50%); /* 垂直居中对齐 */
          width: 12px; /* 圆形的宽度 */
          height: 12px; /* 圆形的高度 */
          background-color: #17c5fd; /* 圆形的背景颜色 */
          border-radius: 50%; /* 创建圆形 */
        }
        &.water:before {
          content: '';
          position: absolute;
          left: -20px; /* 将圆形置于文本左侧 */
          top: 50%;
          transform: translateY(-50%); /* 垂直居中对齐 */
          width: 12px; /* 圆形的宽度 */
          height: 12px; /* 圆形的高度 */
          background-color: #accfff; /* 圆形的背景颜色 */
          border-radius: 50%; /* 创建圆形 */
        }
      }
    }
  }
  .line {
    display: flex;
    height: 25%;
    width: 100%;
    .box {
      width: 33.33%;
    }
    .btn-box {
      display: flex;
      justify-content: center;
      align-items: center;
      .btn {
        color: #fff22f;
        font-size: 18px;
        font-weight: bold;
        padding: 5px 10px;
        border-radius: 4px;
        width: 150px;
        cursor: pointer;
        background-image: url('@/assets/img/bottomPlat.png');
        background-size: 100% 100%;
        height: 50px;
      }
    }
  }
  .table-box {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 35%;
    // padding: 0 15px 15px;
    margin-top: 10px;
    .box {
      width: 90%;
      background-image: url('@/assets/img/modelBg4.png');
      background-size: 100% 100%;
      .table {
        width: calc(100% - 30px);
        height: calc(100% - 15px);
        margin: 7px 15px;
      }
    }
  }
}
</style>